import api from '@pray/shared/utils/api';
import { ObjectResponse } from '@pray/shared/utils/api/types/response';

import { UpdateUnsubscribeGroupRequest } from './types';

type Props = { artistId: string; groupId: number; data: UpdateUnsubscribeGroupRequest };

export const updateUnsubscribeGroup = async ({ artistId, groupId, data }: Props) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!groupId) throw Error('Group ID is required');

  const url = `/web/studio/artists/${artistId}/unsubscribe-groups/${groupId}`;

  const response = await api.executePatchRequest<ObjectResponse<unknown>>(url, data);

  return response.data;
};
